import * as S from "./style";

const Error: React.FC = ({ children }) => {
  return <S.Base>{children}</S.Base>;
};

export default Error;
